import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import UsersController from './users.controller';
import { Button } from 'antd';
import { Users, Plus } from 'lucide-react';

import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import { UserActions, UserDrawer, UsersTable, UserAnalytics } from './elements';

class ShelfUsers extends Inherit(UsersController, Component) {
    state = {
        isOpen: false,
        loading: true,
        users: [],
        rows: [],
        clients: [],
        selectedUser: null
    };

    render() {
        const { users, rows, loading, isOpen, selectedUser, clients } = this.state;

        return (
            <Layout current="users">
                {this.props.contextHolder}

                <PageHeader
                    icon={<Users />}
                    title="Usuarios"
                    description="Gestiona el equipo y sus permisos"
                    actions={
                        !loading && (
                            <Button type="primary" icon={<Plus />} onClick={() => this.setIsOpen(true)}>
                                Crear Usuario
                            </Button>
                        )
                    }
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={4} />
                        <TableSkeleton rows={10} columns={6} />
                    </div>
                ) : (
                    <>
                        {/* Analytics */}
                        <UserAnalytics users={users} />

                        {/* Search, status filter & table */}
                        <section className="shelf-card overflow-hidden">
                            <div className="border-b border-surface-100 px-5 py-4">
                                <UserActions setRows={this.setRows.bind(this)} users={users} />
                            </div>
                            <UsersTable rows={rows} loading={loading} showEditDrawer={this.showEditDrawer.bind(this)} />
                        </section>

                        <UserDrawer
                            isOpen={isOpen}
                            setIsOpen={this.setIsOpen.bind(this)}
                            selectedUser={selectedUser}
                            setSelectedUser={this.setSelectedUser.bind(this)}
                            createOrUpdateUser={this.createOrUpdateUser.bind(this)}
                            contextHolder={this.props.contextHolder}
                            clients={clients}
                            fetchStoresByClient={this.fetchStoresByClient.bind(this)}
                            fetchStoreById={this.fetchStoreById.bind(this)}
                        />
                    </>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfUsers);
